import { ImageBackground, View } from 'react-native';
import cloudsImage from '../../assets/images/clouds.jpg';

const CloudBackground = ({ children, ...props }) => {
  // Use the asset directly with ImageBackground since it's a local asset
  return (
    <View style={{ backgroundColor: "black", flex: 1 }}>
      <ImageBackground source={cloudsImage} style={{ width: '100%', height: '100%', flex: 1 }}>
        {children}
      </ImageBackground>
    </View>
  );
};

export default CloudBackground;
